import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import Table from "../../../../Componets/Table";
import { get_all_delivery_note } from "../../../../Controllers/Sales/DO";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Sales/DO/tables";
import headers from "../../../../Data/Tables/Sales/DO/headers";
import Loadercomponent from "../../../../Componets/Loader";
import moment from "moment";
import DateTimeBadge from "../../../../Componets/DateTime/DateTimeBadge";

const DeliveryNoteTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      customer: headerdata?.customer,
      sales_order: headerdata?.sales_order,
      date: headerdata?.date,
      due_date: headerdata?.due_date,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      customer: headerdata?.customer,
      sales_order: headerdata?.sales_order,
      date: headerdata?.date,
      due_date: headerdata?.due_date,
      status: headerdata?.status,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        customer: tabledata?.customer,
        sales_order: tabledata?.sales_order,
        status: tabledata?.status,
        date: tabledata?.date,
        due_date: tabledata?.due_date,
        page: tabledata?.currentPage,
      };

      const delivery_note = await get_all_delivery_note(data);
      if (delivery_note?.status) {
        let dataArray = [];

        delivery_note?.data?.data?.map((value, index) => {
          dataArray?.push({
            path: `/app/sales/delivery-note/view/${value?._id}`,
            Number: `#DN-${value?.number}`,
            "Sales Order": `#SO-${value?.sales_order?.number}`,
            Customer: value?.customer?.name
              ? value?.customer?.name
              : "Walk-in-customer",
            Date: <DateTimeBadge date={value?.date} />,
            Due: value?.due_date
              ? moment(value?.due_date).format("MMMM Do YYYY")
              : "-",
            Total: value?.total?.toFixed(3),
            Status: <Status status={value?.status} />,
            Action: (
              <ActionButton
                edit={`/app/sales/delivery-note/edit/${value?._id}`}
                id={value?._id}
                api="delete-delivery-note"
                actiondata={actiondata}
                source={"Sales"}
                headers={header}
              />
            ),
          });
        });

        setPagination({
          currentPage: delivery_note?.data?.currentPage,
          totalCount: delivery_note?.data?.totalCount,
          totalPages: delivery_note?.data?.totalPages,
        });

        setBody(dataArray);
        setLoader(false);
      } else {
        toast?.error(delivery_note?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default DeliveryNoteTable;